class Microcopy {
  constructor(microcopy) {
    this.code = "en"
    this.CODE = "EN"
    this.copy = {}
    this._microcopy = microcopy

    if (!microcopy) {
      return
    }
    this.init()
  }

  init() {
    Object.entries(this._microcopy).forEach(
      ([key, value]) => (this[key] = value),
    )
    this.CODE = this._microcopy.code.toUpperCase()

    if (this._microcopy.serialized) {
      this.copy = JSON.parse(this._microcopy.serialized)
    }
  }

  text(key, ifNull = null) {
    const parts = key.trim().split(".")
    const value = this.value(this, ["copy", ...parts])
    if (value) {
      return value
    }
    if (ifNull) {
      return ifNull
    }
    return parts.reverse()[0]
  }

  // PRIVATE

  value(object, [key, ...keys]) {
    const next = object[key]
    if (!next || keys.length === 0) {
      return next
    }
    return this.value(next, keys)
  }
}

export default Microcopy
